import { Button, Empty, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Show } from "@refinedev/antd";
import { AppTitle } from "components";
import { MaterialBlockCard } from "./MaterialBlockCard";
import { useMedicineMaterials } from "./useMedicineMaterials";
import { MedicineDigestsTable } from "../Medicine-Digests/MedicineDigestsTable";
import { MedicineAnnouncementsTable } from "../Medicine-Announcements/MedicineAnnouncementsTable";
import { HelpfulMaterialsTable } from "../Helpful-Materials/HelpfulMaterialsTable";
import { MedicinePublicationsTable } from "../Medicine-Publications/MedicinePublicationsTable";

export const MedicineMaterials = () => {
  const {
    blocks,
    loading,
    removingIds,
    savingBlockKey,
    addBlock,
    addDraftImage,
    removeBlock,
    removeDraftImage,
    removeMaterial,
    saveBlock,
    updateBlockCaption,
    updateDraft,
  } = useMedicineMaterials();

  return (
    <Show
      isLoading={loading}
      title={<AppTitle canGoBack>Полезные материалы по медицине</AppTitle>}
      breadcrumb={false}
      headerButtons={
        <Button type="primary" icon={<PlusOutlined />} onClick={addBlock}>
          Добавить блок
        </Button>
      }
      footerButtons={null}
      goBack={false}
    >
      {/* Порядок блоков задан продуктом: анонсы, статьи, тезисы,
          информационно-образовательные материалы, полезные файлы, дайджест. */}
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <MedicineAnnouncementsTable />
        <MedicinePublicationsTable kind="ARTICLE" />
        <MedicinePublicationsTable kind="THESIS" />
        {!blocks.length ? (
          <Empty description="Материалы отсутствуют" />
        ) : (
          blocks.map((block) => (
            <MaterialBlockCard
              key={block.key}
              block={block}
              isSaving={savingBlockKey === block.key}
              isRemoving={block.materials.some((material) =>
                removingIds.includes(material.id)
              )}
              removingIds={removingIds}
              onAddDraft={addDraftImage}
              onRemoveBlock={removeBlock}
              onRemoveDraft={removeDraftImage}
              onRemoveMaterial={removeMaterial}
              onSave={saveBlock}
              onUpdateCaption={updateBlockCaption}
              onUpdateDraft={updateDraft}
            />
          ))
        )}
        <HelpfulMaterialsTable />
        <MedicineDigestsTable />
      </Space>
    </Show>
  );
};
